import type { Paragraph, TextRun } from '@/api/types/stowed-element'

/**
 * Maps each flat-text character index to its source TextRun. Paragraph separators map to null: one
 * for every paragraph after the first, so the map is exactly as long as `paragraphsToPlainText`.
 *
 * The break is keyed on the paragraph's position, not on the map already holding something. The old
 * `map.length > 0` test skipped the break after a leading EMPTY paragraph, and every later
 * character's run then sat one place left of its offset (WMPCM-11367).
 */
export function buildCharRunMap(paragraphs: Paragraph[]): Array<TextRun | null> {
  const map: Array<TextRun | null> = []

  for (const [paragraphIndex, para] of paragraphs.entries()) {
    if (paragraphIndex > 0) map.push(null)
    for (const line of para.textLines ?? []) {
      for (const run of line.textRuns ?? []) {
        for (const _ch of run.textContent ?? '') map.push(run)
      }
    }
  }

  return map
}

export function paragraphsToPlainText(paragraphs: Paragraph[]): string {
  return paragraphs
    .map((paragraph) =>
      (paragraph.textLines ?? [])
        .map((line) => (line.textRuns ?? []).map((run) => run.textContent ?? '').join(''))
        .join('')
    )
    .join('\n')
}
